import { z } from 'zod/v4-mini';

import { Gender, genderSchema } from '@/models/GenderModel';
import { Profession, professionSchema } from '@/models/ProfessionModel';
import { User, userSchema } from '@/models/UserModel';
import { Schema, cz } from '@/utils/zodUtils.ts';

/*********************************
 *         Practitioner          *
 *********************************/

export type Practitioner = {
  id: string;
  user: User;
  givenName: string;
  familyName: string;
  contactPhone?: string;
  addressLine?: string;
  addressCity?: string;
  addressPostalCode?: string;
  addressCountry?: string;
  gender?: Gender;
  birthDate?: string;

  qualification: Profession;

  franceRPPS?: string;
  updatedAt: string;
  createdAt: string;
};

export type PractitionerSummary = {
  id: string;
  givenName: string;
  familyName: string;
  contactPhone?: string;
  qualification: string;
};

export const practitionerSchema: Schema<Practitioner> = z.pipe(
  z.object({
    user: userSchema,
    givenName: z.string(),
    familyName: z.string(),
    contactPhone: cz.optional(z.string()),
    addressLine: cz.optional(z.string()),
    addressCity: cz.optional(z.string()),
    addressPostalCode: cz.optional(z.string()),
    addressCountry: cz.optional(z.string()),
    gender: cz.optional(genderSchema),
    birthDate: cz.optional(z.string()),
    qualification: professionSchema,
    franceRPPS: cz.optional(z.string()),
    updatedAt: z.string(),
    createdAt: z.string(),
  }),
  z.transform(data => ({ ...data, id: data.user.id })),
);

export const practitionerSummarySchema: Schema<PractitionerSummary> = z.pipe(
  z.object({
    user_id: z.string(),
    givenName: z.string(),
    familyName: z.string(),
    contactPhone: cz.optional(z.string()),
    qualification: professionSchema,
  }),
  z.transform(data => ({ ...data, id: data.user_id })),
);

export type UpdatePractitioner = {
  givenName?: string;
  familyName?: string;
  contactPhone?: string;
  addressLine?: string;
  addressCity?: string;
  addressPostalCode?: string;
  addressCountry?: string;
  gender?: Gender;
  birthDate?: string;
  qualification?: Profession;
};
